import { render, staticRenderFns } from "./NicheSalesForm.vue?vue&type=template&id=f5f94784&"
import script from "./NicheSalesForm.vue?vue&type=script&lang=js&"
export * from "./NicheSalesForm.vue?vue&type=script&lang=js&"
import style0 from "./NicheSalesForm.vue?vue&type=style&index=0&id=f5f94784&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports